var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigma(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.818 21.61c1.757 0 3.183-1.435 3.183-3.203v-3.203H8.818c-1.755 0-3.181 1.434-3.181 3.203s1.426 3.204 3.181 3.204z",
    fill: "#00e676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.637 12c0-1.768 1.426-3.203 3.181-3.203h3.183v6.407H8.818c-1.755 0-3.181-1.435-3.181-3.204z",
    fill: "#7c4dff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.637 5.594c0-1.768 1.426-3.204 3.181-3.204h3.183v6.407H8.818c-1.755 0-3.181-1.435-3.181-3.203z",
    fill: "#f4511e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.39h3.182c1.756 0 3.182 1.436 3.182 3.204s-1.426 3.203-3.182 3.203H12z",
    fill: "#ff8a65"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.364 12c0 1.769-1.426 3.204-3.182 3.204S12 13.769 12 12s1.426-3.203 3.182-3.203 3.182 1.435 3.182 3.203z",
    fill: "#29b6f6"
  })));
}
export default SvgFigma;